// extracted by mini-css-extract-plugin
export var card = "_ls-1";
export var summary = "_ls-0";
export var unreadDot = "_ls-2";